import React from 'react';
import { Helmet } from 'react-helmet-async';

// AdSense Publisher ID from environment variables
// If not defined, fall back to the actual publisher ID
const ADSENSE_PUB_ID = process.env.REACT_APP_ADSENSE_PUBLISHER_ID || 'ca-pub-8882464801503395';

const SEO = ({ 
  title, 
  description, 
  keywords = [],
  canonicalUrl,
  structuredData = null,
  ogImage = '/logo512.png',
  ogType = 'website'
}) => {
  // Set defaults if not provided
  const pageTitle = title ? `${title} - JSON Tools` : 'JSON Tools - Free Online JSON Utilities';
  const pageDescription = description || 'Free online JSON tools including JSON Beautifier, JSON Escape Unescape, JSON Schema Generator, and Schema Validator. No installation required.';
  const keywordsString = [
    'JSON tools', 
    'JSON beautifier', 
    'JSON formatter', 
    'JSON schema generator', 
    'JSON validator',
    'online JSON tools',
    'developer tools',
    ...keywords
  ].join(', ');
  
  // Use environment variable for site domain if available
  const siteDomain = process.env.REACT_APP_SITE_DOMAIN || 'https://yourjsontools.com';
  
  // If no canonical URL specified but we have a path, build the full URL
  const fullCanonicalUrl = canonicalUrl ? 
    (canonicalUrl.startsWith('http') ? canonicalUrl : `${siteDomain}${canonicalUrl}`) : 
    null;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={keywordsString} />
      <meta name="author" content="JSON Tools" />
      
      {/* Canonical URL */}
      {fullCanonicalUrl && <link rel="canonical" href={fullCanonicalUrl} />}
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={ogType} />
      {fullCanonicalUrl && <meta property="og:url" content={fullCanonicalUrl} />}
      <meta property="og:image" content={ogImage.startsWith('http') ? ogImage : `${siteDomain}${ogImage}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="JSON Tools" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={ogImage.startsWith('http') ? ogImage : `${siteDomain}${ogImage}`} />
      <meta name="twitter:creator" content="@jsontoolsapp" />
      
      {/* Mobile Optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      <meta name="theme-color" content="#1976D2" />
      
      {/* Schema.org Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
      
      {/* AdSense Code */}
      <script async src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_PUB_ID}`} crossOrigin="anonymous"></script>
    </Helmet>
  );
};

export default SEO; 